/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 * 
 * ProductDetailsPortrait
 * 
 */
import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as appActions from "../../../store/actions/appActions";
import * as utils from "../../../basics/utils";
import VideoFrame from "../../partials/VideoFrame";
import ProductMain from "./ProductMain";
import ProductFree from "./ProductFree";
import ProductDocuments from "./ProductDocuments";
import GalleryController from '../imageGallery/GalleryController';
import { MdPhotoCamera, MdOutlinePhotoCamera } from "react-icons/md";
import { BsCameraVideo, BsCameraVideoFill } from "react-icons/bs";

class ProductPortrait extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;
    }

    // ==========================================================================
    //
    // RENDER - SECTION
    //
    // ==========================================================================
    render() {
        const { inputHeight, headerHeight, path, orientation, iPhone, appModus, toolbarType, galleryGroup, currentContainer } = this.props.app

        const dialog = utils.getDialogByPath(path);

        if (dialog.product === '') return null;

        const node = utils.getTreePortfolio(path, false);
        if (node === null) return null;

        const videoList = utils.getNodeFiles(node, 'mp4');

        // ==========================================================================
        // 
        // SUB RENDER
        // 
        // ==========================================================================

        // ###############################################################
        // Oberer Bereich der Produktdetails
        // - Großes Produktbild
        // ###############################################################
        const renderUpper = () => {

            const style = { height: '55%' };

            return (
                <div className="w-full h-full flex-col pb-2 px-2" style={style}>
                    <ProductMain node={node} />
                </div>
            )
        }

        // ###############################################################
        // Unterer Bereich der Produktdetails
        // - Freigestelltes Produktbild
        // - Videoliste
        // - Produktdokumente
        // ###############################################################
        const renderLower = () => {

            const renderLeft = () => {
                const style = { background: this.debug ? 'yellow' : '' };

                return (
                    <div className={"w-1/2 h-full " + (iPhone ? 'px' : 'px-2')} style={style}>
                        <ProductFree node={node} />
                    </div>
                )
            }

            const renderRight = () => {

                const renderVideoList = () => {

                    const renderVideo = (d, i) => {
                        return (<VideoFrame key={i} fileName={d.name} type='product' />)
                    }

                    //const scrollBarClass = (window['cordova']) ? 'overflow-y-hidden' : 'overflow-y-auto';

                    const className = (orientation === 'portrait') ? 'flex-col overflow-y-auto overflow-x-hidden' : 'flex-row overflow-x-auto overflow-y-hidden';

                    return (
                        <div className={`flex w-full h-full ${className}`}>
                            {appModus === 'Admin' && renderVideo({ name: '_NEW', path: '' })}
                            {videoList.map((d, i) => renderVideo(d, i))}
                        </div>
                    )
                }

                const renderTabIcon = (tab, idx) => {
                    const renderIcon = () => {
                        if (tab.label === 'Videos') {
                            return galleryGroup === idx ? <BsCameraVideoFill /> : <BsCameraVideo />
                        }
                        if (tab.label === 'Bilder') {
                            return galleryGroup === idx ? <MdPhotoCamera /> : <MdOutlinePhotoCamera />
                        }
                    }

                    return (
                        <div className="w-full text-5xl text-gray-800 px" >
                            {renderIcon()}
                        </div>
                    )
                }

                const renderGalleryGroup = () => {
                    const className = "h-full w-1/2 px-2 pt-2 pb-2 text-center font-bold text-xl flex items-center justify-center"
                    const classNameAus = `${className} text-gray-400 border-t-8 border-transparent`;
                    const classNameEin = `${className} text-black border-t-8 border-gray-800`;

                    const tabs = [{ label: "Videos" }, { label: "Bilder" }];

                    return (
                        <div className="flex w-full h-full flex-col">
                            <div className="flex h-1/6">
                                {tabs.map((tab, idx) => (
                                    <div onClick={() => this.props.setGalleryGroup(idx)}
                                        className={galleryGroup === idx ? classNameEin : classNameAus}
                                        key={tab.label}>
                                        {renderTabIcon(tab, idx)}
                                    </div>
                                ))}
                            </div>
                            <div className="flex h-5/6">
                                {galleryGroup === 0 && renderVideoList()}
                                {galleryGroup === 1 && GalleryController()}
                            </div>
                        </div>
                    );
                }

                // ###############################################################
                // renderRight
                // ###############################################################

                if (currentContainer === 'regal-lagersysteme') {
                    return (
                        <div className="w-1/2 h-full flex" >
                            <div className="w-4/6 h-full flex" >
                                <ProductDocuments />
                            </div>
                            <div className="w-2/6 h-full flex" >
                                {renderGalleryGroup()}
                            </div>
                        </div>
                    )
                } else {
                    if (videoList.length > 0) {
                        return (
                            <div className="w-1/2 h-full flex" >
                                <div className="w-4/6 h-full flex" >
                                    <ProductDocuments />
                                </div>
                                <div className="w-2/6 h-full flex" >
                                    {renderVideoList()}
                                </div>
                            </div>
                        )
                    } else {
                        return (
                            <div className="w-1/2 h-full flex" >
                                <ProductDocuments />
                            </div>
                        )
                    }
                }
            }

            // ###############################################################
            // renderLower
            // ###############################################################
            const style = {
                height: '45%',
                background: 'rgb(233,237,243)',
            };

            return (
                <div className="w-full flex h-full p-2" style={style}>
                    {renderLeft()}
                    {renderRight()}
                </div>
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================         
        let style = {
            top: headerHeight + 'px',
            height: inputHeight + 'px'
        };

        if (orientation === 'portrait') {
            style = { height: (inputHeight + headerHeight) + 'px' };
        }

        if (!(dialog.dialogType === 'products' && orientation === 'portrait')) return null;

        if (['search', 'filter', 'favored'].includes(toolbarType)) return null;

        return (
            <div className="ProductPortrait w-full flex flex-col z-20 bg-forsales-gray overflow-hidden" style={style}>
                {renderUpper()}
                {renderLower()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductPortrait);
